module.exports = __webpack_public_path__ + "img/wujinmu5.885d77c9.jpg";